import styled from "styled-components"
import { motion } from "framer-motion"

export const TileImage = styled.img`
  z-index: 1;
  object-fit: cover;
  min-width: 100%;
  height: 100%;
`

export const AboutContainer = styled(motion.div)`
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  width: 100vw;
  height: 100%;
`

export const AboutCard = styled.div`
  z-index: 2;
  position: relative;
  width: 50%;
  height: 50%;
  cursor: pointer;
`

export const TitleWraper = styled.div`
  z-index: 2;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
`

export const MainTitle = styled.div`
  z-index: 2;
  font-size: 5vw;
  line-height: 150%;
  width: 100%;
  font-family: "Lora-Regular";
  color: white;
`

export const SubTitle = styled.div`
  z-index: 2;
  font-size: 1vw;
  line-height: 120%;
  width: 100%;
  letter-spacing: 0.17em;
  font-family: "AzoSans-Regular";
  color: white;
`

export const BackgroundWraper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

export const FogBox = styled.div`
  z-index: 3;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: ${({ backgroundColor }) => backgroundColor};
`
